import { TableColumn } from '../../../../table/interfaces/table';
import { JobObjectStage } from '../../../interfaces/job';
import { Calendar } from '../../../../shared/components/Calendar/Calendar';
import Duration from '../../../../shared/components/Duration/Duration';
import { RenderEventCell } from '../../EventCell';
import { GenericStatusLabel } from '../../../../shared/components/GenericStatusLabel/GenericStatusLabel';

export const objectStagesTableColumns: TableColumn<JobObjectStage>[] = [
  {
    id: 'name',
    field: 'stage',
    headerName: 'Stage',
    renderCell: params => <span className='text-capitalize'>{params.row.data.stage}</span>,
    width: 130,
    isFlexible: true
  },
  {
    id: 'started_at',
    field: 'startedAt',
    headerName: 'Started At',
    width: 160,
    renderCell: params => (
      <Calendar value={params.row.data.startedAt} options={{ hideZeroTimestamp: true }} />
    )
  },
  {
    id: 'duration',
    field: 'duration',
    headerName: 'Duration',
    width: 90,
    renderCell: params => (
      <Duration
        duration={params.row.data.duration}
        options={{ useAbbr: true, separateUnits: true }}
      />
    )
  },
  {
    id: 'ingested',
    field: 'inputEvents',
    headerName: '# Input',
    description: 'Count of Input Events',
    width: 80,
    justifyEnd: true,
    renderCell: params => <RenderEventCell count={params.row.data.inputEvents} />
  },
  {
    id: 'loaded',
    field: 'outputEvents',
    headerName: '# Output',
    description: 'Count of Output Events',
    width: 80,
    justifyEnd: true,
    renderCell: params => <RenderEventCell count={params.row.data.outputEvents} />
  },
  {
    id: 'failed',
    field: 'failedEvents',
    headerName: '# Failed',
    description: 'Count of Failed Events',
    width: 80,
    justifyEnd: true,
    renderCell: params => <RenderEventCell count={params.row.data.failedEvents} />
  },
  {
    id: 'status',
    field: 'status',
    headerName: 'Status',
    width: 170,
    justifyEnd: true,
    renderCell: params => <GenericStatusLabel status={params.row.data.status} />
  }
];
